export const GetTransfer = ({ sideId, walletTypeId, coinId }) =>
  `/SpotWallet/GetTransfer?SideId=${sideId}&WalletTypeId=${walletTypeId}&CoinId=${coinId}`;

// NOTE: walletTypeId is always 2, it should be changed from both backend and frontend sides.
// Please remove this comment if you changed it !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
export const GetTransferAmountMax = ({ sideId, walletTypeId, coinId }) =>
  `/SpotWallet/GetTransferAmountMax?SideId=${sideId}&WalletTypeId=${walletTypeId}&CoinId=${coinId}`;

export const TransferInsert = `/SpotWallet/TransferInsert`;
